import {elys} from '@elys-network/elys-telescope';
import {
  QueryAirDropResponse,
  //QueryKolResponse,
  // QueryKolResponse,
  QueryRewardProgramResponse,
} from '@elys-network/elys-telescope/elys/commitment/query';
import {useMutation} from '@tanstack/react-query';
import {useQueryChainModule} from './elys/useQueryChainModule';
import {useExecuteChainModule} from './elys/useExecuteChainModule';

export enum ElegibilityStatus {
  notElegible = 0,
  elegible = 1,
  claimed = 2,
  periodOver = 3,
  notStarted = 4,
}

// const getKolStatus = (data: QueryKolResponse | undefined | null) => {
//   if (!data || data.elysAmount === '0')
//     return {status: ElegibilityStatus.notElegible, total: 0};

//   const total = parseFloat(data.elysAmount);
//   let status = ElegibilityStatus.elegible;
//   if (data.claimed) {
//     status = ElegibilityStatus.claimed;
//   }

//   return {status, total};
// };
// }

const getAirdropStatus = (data: QueryAirDropResponse | QueryRewardProgramResponse | null | undefined) => {
  if (!data) return {status: ElegibilityStatus.notElegible, total: 0};
  const elysTotal = Object.entries(data)
    .filter(
      ([key, value]) => typeof value === 'string' && key !== 'atomStaking',
    )
    .reduce((sum, [, value]) => sum + parseFloat(value || '0'), 0);
  const total = Object.entries(data).reduce(
    (sum, [, value]) => sum + parseFloat(value || '0'),
    0,
  );
  let status = ElegibilityStatus.notElegible;
  if (data.claimed) {
    status = ElegibilityStatus.claimed;
  }
  if (!data.claimed && (total > 0 || elysTotal > 0)) {
    status = ElegibilityStatus.elegible;
  }
  return {status, total, elysTotal};
};

export const useGetElegibility = (address: string) => {
  const {data, isLoading, refetch} = useQueryChainModule(
    {
      module: 'elys.commitment.rewardProgram',
      data: {address},
    },
    {enabled: !!address},
  );
  const {status, total, elysTotal} = getAirdropStatus(data);
  return {data, isLoading, status, total, elysTotal, refetch};
};

export const useAcceptAirdrop = () => {
  const {execute} = useExecuteChainModule();
  const mutation = useMutation({
    mutationFn: async (address?: string) => {
      if (!address) return;
      const msg =
        elys.commitment.MessageComposer.withTypeUrl.claimRewardProgram({
          claimAddress: address,
        });

      console.log(msg);

      await execute([msg]);
    },
  });
  return mutation;
};

// export const useGetKol = (address: string) => {
//   const {data, isLoading} = useQueryChainModule(
//     {
//       module: 'elys.commitment.kol',
//       data: {
//         address,
//       },
//     },
//     {enabled: !!address},
//   );
//   const {status, total} = getKolStatus(data);
//   return {data, isLoading, status, total};
// };

export const useClaimKol = () => {
  const {execute} = useExecuteChainModule();
  const mutation = useMutation({
    mutationFn: async (body: {address: string; refund: boolean}) => {
      if (!body.address) return;
      const msg = elys.commitment.MessageComposer.withTypeUrl.claimKol({
        claimAddress: body.address,
        refund: body.refund,
      });

      await execute([msg]);
    },
  });
  return mutation;
};

export const useGetEdenElegibility = (address: string) => {
  const query = useQueryChainModule(
    {
      module: 'elys.commitment.totalRewardProgramClaimed',
      data: {
        address,
      },
    },
    {enabled: !!address},
  );
  console.log('query', query.data);
  return query;
};
